import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, fmtDate } from "@/lib/api";

const COURSES = [["ai", "AI Website Development Course"], ["nomad", "Become a Digital Nomad for Beginners"]];

export function HostCertificates({ studentId }) {
  const [certs, setCerts] = useState([]);
  const load = () => api.get(`/admin/students/${studentId}/certificates`).then((r) => setCerts(r.data)).catch(() => {});
  useEffect(() => { load(); }, [studentId]); // eslint-disable-line react-hooks/exhaustive-deps
  const award = (key) => api.post(`/admin/students/${studentId}/certificate/${key}`).then(() => { toast.success("Certificate awarded · student notified"); load(); }).catch((e) => toast.error(formatApiError(e)));
  const revoke = (id) => api.delete(`/admin/certificates/${id}`).then(() => { toast.success("Certificate removed"); load(); }).catch((e) => toast.error(formatApiError(e)));
  return (
    <div className="bg-white rounded-2xl border border-[#F08A3C]/40 p-5 flex flex-col gap-3" data-testid="host-certificates">
      <p className="flex items-center gap-2 font-semibold text-[#0B2A4A]"><Award className="h-4 w-4 text-[#F08A3C]" /> Certificates</p>
      {COURSES.map(([key, name]) => {
        const c = certs.find((x) => x.course === name);
        return (
          <div key={key} className="flex flex-wrap items-center justify-between gap-2 text-sm border-b border-dashed border-[#0B2A4A]/10 pb-2">
            <span>{name}{key === "nomad" && <span className="text-xs text-slate-400"> · auto-awarded when all 7 days are complete</span>}</span>
            {c ? (
              <span className="flex gap-2">
                <Link to={`/certificate/${c.id}`} className="rounded-lg bg-emerald-600 text-white px-3 py-1.5 text-xs font-semibold" data-testid={`host-cert-view-${key}`}>View · {fmtDate(c.issued_at)}</Link>
                <button onClick={() => revoke(c.id)} className="rounded-lg border border-[#0B2A4A]/20 px-3 py-1.5 text-xs" data-testid={`host-cert-revoke-${key}`}>Remove</button>
              </span>
            ) : <button onClick={() => award(key)} className="rounded-lg bg-[#F08A3C] text-white px-3 py-1.5 text-xs font-semibold" data-testid={`host-cert-award-${key}`}>Award certificate</button>}
          </div>
        );
      })}
    </div>
  );
}
